"use strict";
require("./..\\..\\..\\bower_components\\jQuery-viewport-checker\\dist\\jquery.viewportchecker.min.js");

module.exports = function () {

	$('.targets-list__item, .services-list, .benefits-list__item, .steps, .development__list').viewportChecker({
		classToAdd: 'animate',
		offset: '30%'
	});

};